import { SpacingOptions } from '@material-ui/core/styles/createSpacing';

export const initializeSpacing = (value?: SpacingOptions): SpacingOptions => {
  return value || 4;
};
